import { Action } from 'redux'
import { isType } from 'ts-action'
import { IExperienceReducer } from 'models/Experience'
import { GetExperiences, ExperiencesFetching } from './actions'

const initialState: IExperienceReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const experiencesReducer = (
  state = initialState,
  action: Action,
): IExperienceReducer => {
  if (isType(action, GetExperiences)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, ExperiencesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
